module.exports = __webpack_public_path__ + "static/media/certificate-enrolled-1-3.e0706dd7.svg";